import {List, ListItem, ListItemIcon, ListItemText, Typography} from "@material-ui/core";
import React, {useState} from "react";
import Tr from "translations/Translations";
import Dialog from "components/Dialog";
import Loading from "components/Loading";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Checkbox from "components/Checkbox";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    loading: {
        width: '92%'
    },
}))

const PapersGeneratorSelectFilesPopup = (
    {
        list,
        title,
        onClose,
        onBack,
        onGenerate,
        working
    }) => {
    const classes = useStyle();
    const [selectedPos, setSelectedPos] = useState([]);

    const generateClick = () => onGenerate(selectedPos);

    const getButtons = () => {
        const buttons = [];
        if(!!onBack) {
            buttons.push(createButton(Tr('back'), onBack, 'outlined'));
        }
        buttons.push(createButton(Tr('close'), onClose, 'outlined'));
        buttons.push(createButton(Tr('generate_report'), generateClick, undefined, working || selectedPos.length === 0));
        return buttons;
    }

    const onSelect = (supplier) => {
        if(working)
            return;
        const added = selectedPos.indexOf(supplier.id) === -1;
        if (added) {
            setSelectedPos(x => [...x, supplier.id]);
        } else {
            setSelectedPos(x => x.filter(x => x !== supplier.id));
        }
    }

    return (<Dialog
        title={title}
        open
        maxWidth='md'
        onClose={onClose}
        dialogActions={<MultiButton buttons={getButtons()} />}
    >
        {(working || !list) && <Loading  className={classes.loading}/>}
        {(!!list && list.length > 0) && <List dense>
            {list.map((position) =>
                <ListItem key={position.id} button onClick={() => onSelect(position)}>
                    <ListItemIcon>
                        <Checkbox
                            color='primary'
                            checked={selectedPos.indexOf(position.id) > -1}
                            onChange={() => onSelect(position)}
                            disabled={working}
                        />
                    </ListItemIcon>
                    <ListItemText primary={position.name}/>
                </ListItem>)}
        </List>}
        {(!!list && list.length === 0) && <Typography>{Tr('no_options')}</Typography>}
    </Dialog>)
}

export default PapersGeneratorSelectFilesPopup;